module.exports = __webpack_public_path__ + "img/logo.b3e2cfb5.png";